module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg4@3x.b5c9f4ef.png";